import { render, staticRenderFns } from "./AdminTheming.vue?vue&type=template&id=4f7ac635&scoped=true&"
import script from "./AdminTheming.vue?vue&type=script&lang=js&"
export * from "./AdminTheming.vue?vue&type=script&lang=js&"
import style0 from "./AdminTheming.vue?vue&type=style&index=0&id=4f7ac635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7ac635",
  null
  
)

export default component.exports